module.exports = __webpack_public_path__ + "static/img/bg.054b6b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big-screen/bg.png
// module id = 3k1G
// module chunks = 32